'use client';

import { useEffect } from 'react';

const useBlockScroll = (shouldBlock = true) => {
  useEffect(() => {
    if (!shouldBlock) return;

    // Get initial overflow style
    const originalStyle = window.getComputedStyle(document.body).overflow;

    // Prevent scrolling
    document.body.style.overflow = 'hidden';

    // Cleanup function to restore original overflow
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [shouldBlock]);
};

export default useBlockScroll;
